"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModeratorKitContainer", {
  enumerable: true,
  get: function get() {
    return _ModeratorKit.ModeratorKitContainer;
  }
});

var _ModeratorKit = require("./ModeratorKit");